import api from "./configuration";
import apiUrl from "./url";

const request = async (path, method = "GET", data, params) =>
	(
		await api.request({
			url: apiUrl + path,
			method,
			data,
			params,
			useAuthInterceptor: true,
		})
	).data;
export const ScoutingReportsAPI = {
	list: (seasonId) => request("/ScoutingReports", "GET", undefined, {seasonId}),
	get: (id) => request("/ScoutingReports/" + id),
	save: (data) =>
		request(
			"/ScoutingReports" + (data.id ? "/" + data.id : ""),
			data.id ? "PUT" : "POST",
			data,
		),
	remove: (id, version) =>
		request("/ScoutingReports/" + id, "DELETE", undefined, {version}),
	templates: () => request("/ScoutingReportTemplates"),
	saveTemplate: (data) =>
		request(
			"/ScoutingReportTemplates" + (data.id ? "/" + data.id : ""),
			data.id ? "PUT" : "POST",
			data,
		),
	removeTemplate: (id, version) =>
		request("/ScoutingReportTemplates/" + id, "DELETE", undefined, {version}),
	defaults: () => request("/ScoutingReportTemplates/defaults", "POST"),
};
